import React from 'react';
import { Flex, HStack, VStack } from '@saucelabs/sl-component-grid';
import { LabelBadge } from '@saucelabs/sl-component-label';

import { Subscription } from '../../../records/Subscription';
import { amountSeparator } from '../../../utils/numbers';
import { SubscriptionBox } from './SubscriptionBox';
import { ConcurrencyBox } from './ConcurrencyBox';
import { PriceEntry } from './PriceEntry';
import Styles from './SubscriptionBoxes.styles';

interface LegacyPlanProps {
  subscription: Subscription
}
const LegacyPlan: React.FC<LegacyPlanProps> = ({ subscription }) => {
  const price = amountSeparator(subscription.getMonthlyPrice());
  const cadence = subscription.getIntervalLabel();
  return (
    <SubscriptionBox>
      <VStack gap={1}>
        <LabelBadge
          color="orange"
          isBlock
        >
          By making changes to your account, your legacy plan will be overwritten by new changes.
        </LabelBadge>
        <strong className="text-base">
          {`Current plan: ${subscription.displayName()}`}
        </strong>
      </VStack>
      <Flex>
        <ul className={Styles.features}>
          <li className="text-gray-600">
            {`${cadence} plan`}
          </li>
          <li>
            <ConcurrencyBox
              concurrency={subscription.getAddonAmount()}
              subscription={subscription}
            />
          </li>
          <li>
            <PriceEntry
              nextBillDay={subscription.displayNextBillDate()}
              price={price}
            />
          </li>
        </ul>
        <div className="mt-0.5 ml-auto text-right">
          <HStack gap={1}>
            <div>
              Current Monthly Rate:
              {' '}
            </div>
            <strong className="text-base">
              {price}
            </strong>
          </HStack>
          <div className="text-gray-600 text-sm">
            {`${cadence} Billing`}
          </div>
        </div>
      </Flex>
    </SubscriptionBox>
  );
};

export { LegacyPlan };
